/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  Community,
  CommunityDetail,
  CommunityDetailFromJSON,
  CommunityFamiliesReportResponse,
  CommunityFamiliesReportResponseFromJSON,
  CommunityOptions,
  CommunityOptionsFromJSON,
  CommunityToJSON,
  CreateCommunityResponse,
  CreateCommunityResponseFromJSON,
  DeclinePotentialInviteRequestBody,
  DeclinePotentialInviteRequestBodyToJSON,
  FetchAcademicYearsResponse,
  FetchAcademicYearsResponseFromJSON,
  FetchCommunityInvitesResponse,
  FetchCommunityInvitesResponseFromJSON,
  FetchPotentialInviteDeclineReasonsResponse,
  FetchPotentialInviteDeclineReasonsResponseFromJSON,
  FetchPotentialInvitesResponse,
  FetchPotentialInvitesResponseFromJSON,
  InvitationSource,
  PotentialInviteStatus,
  PublicCommunity,
  PublicCommunityFromJSON,
  PublicInternationalCommunity,
  PublicInternationalCommunityFromJSON,
  SearchPublicCommunitiesReply,
  SearchPublicCommunitiesReplyFromJSON,
  SubmitContactFormParams,
  SubmitContactFormParamsFromJSON,
  SubmitContactFormParamsToJSON,
  UpdateCommunity,
  UpdateCommunityToJSON,
} from '../models'
import * as runtime from '../runtime'

export interface CreateCommunityRequest extends runtime.BaseRequestParameters {
  body: Community
}

export interface DeclinePotentialInviteRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
  potentialInviteKey: number
  body: DeclinePotentialInviteRequestBody
}

export interface FetchAcademicYearsRequest
  extends runtime.BaseRequestParameters {
  isLC?: boolean
}

export interface FetchCommunityRequest extends runtime.BaseRequestParameters {
  communityKey: number
}

export interface FetchCommunityFamiliesReportRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
  year?: number
}

export interface FetchCommunityInvitesRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  communityKey?: number
  academicYear?: number
  status?: FetchCommunityInvitesStatusEnum
  search?: string
}

export interface FetchCommunityOptionsRequest
  extends runtime.BaseRequestParameters {}

export interface FetchPotentialInviteDeclineReasonsRequest
  extends runtime.BaseRequestParameters {}

export interface FetchPotentialInvitesRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  academicYear?: number
  source?: InvitationSource
  status?: PotentialInviteStatus
  search?: string
}

export interface SearchPublicCommunitiesRequest
  extends runtime.BaseRequestParameters {
  postalCode?: string
  city?: string
  state?: string
  milesRadius?: number
  usCitiesKey?: number
  programs?: Array<SearchPublicCommunitiesProgramsEnum>
  singleNearest?: boolean
}

export interface SearchPublicCommunityRequest
  extends runtime.BaseRequestParameters {
  publicCommunityId: string
}

export interface SearchPublicInternationalCommunitiesRequest
  extends runtime.BaseRequestParameters {
  country: string
  programs?: Array<SearchPublicInternationalCommunitiesProgramsEnum>
}

export interface SearchPublicInternationalCommunityRequest
  extends runtime.BaseRequestParameters {
  publicCommunityId: string
}

export interface SubmitContactFormRequest
  extends runtime.BaseRequestParameters {
  body?: SubmitContactFormParams
}

export interface UpdateCommunityRequest extends runtime.BaseRequestParameters {
  body: UpdateCommunity
}

/**
 * CommunityApi - interface
 *
 * @export
 * @interface CommunityApiInterface
 */
export interface CommunityApiInterface {
  /**
   * Create a new community within a specific region, with an assigned support representative and fee structure. The response will include a `meta.details` array with updated permissions relative to the just-created community, as you would expect when fetching community details later.
   * @summary Create a new community
   * @param {Community} community
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  createCommunityRaw(
    requestParameters: CreateCommunityRequest
  ): Promise<runtime.ApiResponse<CreateCommunityResponse>>

  /**
   * Create a new community within a specific region, with an assigned support representative and fee structure. The response will include a `meta.details` array with updated permissions relative to the just-created community, as you would expect when fetching community details later.
   * Create a new community
   */
  createCommunity(
    requestParameters: CreateCommunityRequest
  ): Promise<CreateCommunityResponse>

  /**
   * Declines a pending potential invite for a community using the provided decline reason.
   * @summary Decline a potential invite.
   * @param {number} communityKey The unique identifier for a Community.
   * @param {number} potentialInviteKey The unique identifier for a Potential Invite.
   * @param {DeclinePotentialInviteRequestBody} declinePotentialInviteRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  declinePotentialInviteRaw(
    requestParameters: DeclinePotentialInviteRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Declines a pending potential invite for a community using the provided decline reason.
   * Decline a potential invite.
   */
  declinePotentialInvite(
    requestParameters: DeclinePotentialInviteRequest
  ): Promise<void>

  /**
   * Calling this endpoint, you get the list of the academic years from programs.
   * @summary List of academic years.
   * @param {boolean} [isLC] Fetch parent\&#39;s academic years for the LC dropdown.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchAcademicYearsRaw(
    requestParameters: FetchAcademicYearsRequest
  ): Promise<runtime.ApiResponse<FetchAcademicYearsResponse>>

  /**
   * Calling this endpoint, you get the list of the academic years from programs.
   * List of academic years.
   */
  fetchAcademicYears(
    requestParameters: FetchAcademicYearsRequest
  ): Promise<FetchAcademicYearsResponse>

  /**
   *
   * @summary Fetch an existing community
   * @param {number} communityKey The &#x60;communityKey&#x60; is the unique identifier for a Community.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchCommunityRaw(
    requestParameters: FetchCommunityRequest
  ): Promise<runtime.ApiResponse<CommunityDetail>>

  /**
   * Fetch an existing community
   */
  fetchCommunity(
    requestParameters: FetchCommunityRequest
  ): Promise<CommunityDetail>

  /**
   *
   * @summary Report of all enrollments for every family the current user can access within a community, for a single academic year.
   * @param {number} communityKey The &#x60;communityKey&#x60; is the unique identifier for a Community.
   * @param {number} [year] The academic &#x60;year&#x60; to report on. Limits the report to enrollments in programs whose semester one start date falls within that academic year for the community\&#39;s region. Defaults to the community region\&#39;s current academic year.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchCommunityFamiliesReportRaw(
    requestParameters: FetchCommunityFamiliesReportRequest
  ): Promise<runtime.ApiResponse<CommunityFamiliesReportResponse>>

  /**
   * Report of all enrollments for every family the current user can access within a community, for a single academic year.
   */
  fetchCommunityFamiliesReport(
    requestParameters: FetchCommunityFamiliesReportRequest
  ): Promise<CommunityFamiliesReportResponse>

  /**
   * Fetches the invites associated with a community.
   * @summary Fetch community invites
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [communityKey] The &#x60;communityKey&#x60; is the unique identifier for a Community.
   * @param {number} [academicYear] The academic year used to filter community invites.
   * @param {'InProgress' | 'Complete' | 'Cancelled' | 'Declined'} [status] The status used to filter community invites.
   * @param {string} [search] Search term used to filter community invites.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchCommunityInvitesRaw(
    requestParameters: FetchCommunityInvitesRequest
  ): Promise<runtime.ApiResponse<FetchCommunityInvitesResponse>>

  /**
   * Fetches the invites associated with a community.
   * Fetch community invites
   */
  fetchCommunityInvites(
    requestParameters: FetchCommunityInvitesRequest
  ): Promise<FetchCommunityInvitesResponse>

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchCommunityOptionsRaw(
    requestParameters: FetchCommunityOptionsRequest
  ): Promise<runtime.ApiResponse<CommunityOptions>>

  /**
   */
  fetchCommunityOptions(): Promise<CommunityOptions>

  /**
   * Fetches the available reasons for declining a potential invite.
   * @summary Fetch potential invite decline reasons
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchPotentialInviteDeclineReasonsRaw(
    requestParameters: FetchPotentialInviteDeclineReasonsRequest
  ): Promise<runtime.ApiResponse<FetchPotentialInviteDeclineReasonsResponse>>

  /**
   * Fetches the available reasons for declining a potential invite.
   * Fetch potential invite decline reasons
   */
  fetchPotentialInviteDeclineReasons(): Promise<FetchPotentialInviteDeclineReasonsResponse>

  /**
   *      Returns the list of potential invites (Returning Families and LCD Referrals) for a given community.     Supports filtering by academic year, source, status, and a name search.     The actor must have the Family/Invite permission to access this endpoint.     Contact emails are masked for Returning Families and shown in full for LCD Referrals.
   * @summary Fetch a paginated list of potential invites for a community.
   * @param {number} communityKey The &#x60;communityKey&#x60; is the unique identifier for a Community.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [academicYear] The academic year to filter by. Defaults to the current academic year when omitted.
   * @param {InvitationSource} [source]
   * @param {PotentialInviteStatus} [status]
   * @param {string} [search] Search potential invites by family name. Must be at least 3 characters in length.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  fetchPotentialInvitesRaw(
    requestParameters: FetchPotentialInvitesRequest
  ): Promise<runtime.ApiResponse<FetchPotentialInvitesResponse>>

  /**
   *      Returns the list of potential invites (Returning Families and LCD Referrals) for a given community.     Supports filtering by academic year, source, status, and a name search.     The actor must have the Family/Invite permission to access this endpoint.     Contact emails are masked for Returning Families and shown in full for LCD Referrals.
   * Fetch a paginated list of potential invites for a community.
   */
  fetchPotentialInvites(
    requestParameters: FetchPotentialInvitesRequest
  ): Promise<FetchPotentialInvitesResponse>

  /**
   * Returns some communities within a radius of either a postal code (preferred) or a city and state. If programs are provided, then only communities listing all of the requested programs will be included.
   * @summary Find nearby communities with your desired programs so you can reach out about enrolling.
   * @param {string} [postalCode] The postal code to search. Preferred to city+state if supplied.
   * @param {string} [city] The city to search. Ignored if postal code supplied.
   * @param {string} [state] The state to search within. Ignored if postal code supplied.
   * @param {number} [milesRadius] The radius to search within, specified in miles. Extreme values will be capped at a maximum. If omitted, some default behavior will be used.
   * @param {number} [usCitiesKey] A unique identifier for usCities. If postal code is not provided, this key is used for city search.
   * @param {Array<'Foundations' | 'Essentials' | 'Challenge A' | 'Challenge B' | 'Challenge I' | 'Challenge II' | 'Challenge III' | 'Challenge IV'>} [programs] If present and not empty, only communities with all of the listed programs will be returned. If absent or empty, a community\&#39;s available programs has no effect on the results.
   * @param {boolean} [singleNearest] Both limits the search to at most 1 result AND removes any distance limit.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  searchPublicCommunitiesRaw(
    requestParameters: SearchPublicCommunitiesRequest
  ): Promise<runtime.ApiResponse<SearchPublicCommunitiesReply>>

  /**
   * Returns some communities within a radius of either a postal code (preferred) or a city and state. If programs are provided, then only communities listing all of the requested programs will be included.
   * Find nearby communities with your desired programs so you can reach out about enrolling.
   */
  searchPublicCommunities(
    requestParameters: SearchPublicCommunitiesRequest
  ): Promise<SearchPublicCommunitiesReply>

  /**
   * Returns public community details. Note that the `location.distanceMiles`, while included for consistency with the search results, is not meaningful here, and so should be ignored.
   * @summary Review the public details of a community discovered by a location search.
   * @param {string} publicCommunityId The &#x60;publicCommunityId&#x60; is the unique identifier for a Community returned in a search result by the &#x60;searchPublicCommunities&#x60; operation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  searchPublicCommunityRaw(
    requestParameters: SearchPublicCommunityRequest
  ): Promise<runtime.ApiResponse<PublicCommunity>>

  /**
   * Returns public community details. Note that the `location.distanceMiles`, while included for consistency with the search results, is not meaningful here, and so should be ignored.
   * Review the public details of a community discovered by a location search.
   */
  searchPublicCommunity(
    requestParameters: SearchPublicCommunityRequest
  ): Promise<PublicCommunity>

  /**
   * Returns communities that belongs the requested country.     The result should include:      - current active/published communities and those in future *      - Include draft communities *     - Include communities without programs .
   * @summary Search for international communities based on a requested country value,    its deliver the the community information, the community contact and the programs related in case it has.
   * @param {string} country The country value to search communities.
   * @param {Array<'Foundations' | 'Essentials' | 'Challenge A' | 'Challenge B' | 'Challenge I' | 'Challenge II' | 'Challenge III' | 'Challenge IV'>} [programs] If present and not empty, only communities with published programs  will be returned. If absent or empty, a community\&#39;s available programs has no effect on the results.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  searchPublicInternationalCommunitiesRaw(
    requestParameters: SearchPublicInternationalCommunitiesRequest
  ): Promise<runtime.ApiResponse<SearchPublicCommunitiesReply>>

  /**
   * Returns communities that belongs the requested country.     The result should include:      - current active/published communities and those in future *      - Include draft communities *     - Include communities without programs .
   * Search for international communities based on a requested country value,    its deliver the the community information, the community contact and the programs related in case it has.
   */
  searchPublicInternationalCommunities(
    requestParameters: SearchPublicInternationalCommunitiesRequest
  ): Promise<SearchPublicCommunitiesReply>

  /**
   * Returns public community details
   * @summary Search for international community based on a requested community Id encoded,   it delivers the community information, the community contact and the programs related in case it has.
   * @param {string} publicCommunityId The &#x60;publicCommunityId&#x60; is the unique identifier for a Community returned in a search result by the &#x60;searchPublicInternationalCommunities&#x60; operation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  searchPublicInternationalCommunityRaw(
    requestParameters: SearchPublicInternationalCommunityRequest
  ): Promise<runtime.ApiResponse<PublicInternationalCommunity>>

  /**
   * Returns public community details
   * Search for international community based on a requested community Id encoded,   it delivers the community information, the community contact and the programs related in case it has.
   */
  searchPublicInternationalCommunity(
    requestParameters: SearchPublicInternationalCommunityRequest
  ): Promise<PublicInternationalCommunity>

  /**
   * Accepts info about the person requesting contact, which programs they are interested in at which community, and records their acceptance of the relevant legal notices. Be sure to read the description of the 400 Error for details on field-level error reporting, so you can present backend validation errors to the would-be form submitter.
   * @summary Request someone contact you with more details about a community and its programs.
   * @param {SubmitContactFormParams} [submitContactFormParams]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  submitContactFormRaw(
    requestParameters: SubmitContactFormRequest
  ): Promise<runtime.ApiResponse<SubmitContactFormParams>>

  /**
   * Accepts info about the person requesting contact, which programs they are interested in at which community, and records their acceptance of the relevant legal notices. Be sure to read the description of the 400 Error for details on field-level error reporting, so you can present backend validation errors to the would-be form submitter.
   * Request someone contact you with more details about a community and its programs.
   */
  submitContactForm(
    requestParameters: SubmitContactFormRequest
  ): Promise<SubmitContactFormParams>

  /**
   * Create or update a community within a specific region, with an assigned support representative and fee structure.
   * @summary Update an existing community
   * @param {UpdateCommunity} updateCommunity
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApiInterface
   */
  updateCommunityRaw(
    requestParameters: UpdateCommunityRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Create or update a community within a specific region, with an assigned support representative and fee structure.
   * Update an existing community
   */
  updateCommunity(requestParameters: UpdateCommunityRequest): Promise<void>
}

/**
 *
 */
export class CommunityApi
  extends runtime.BaseAPI
  implements CommunityApiInterface
{
  /**
   * Create a new community within a specific region, with an assigned support representative and fee structure. The response will include a `meta.details` array with updated permissions relative to the just-created community, as you would expect when fetching community details later.
   * Create a new community
   */
  async createCommunityRaw(
    requestParameters: CreateCommunityRequest
  ): Promise<runtime.ApiResponse<CreateCommunityResponse>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createCommunity.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: CommunityToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateCommunityResponseFromJSON(jsonValue)
    )
  }

  /**
   * Create a new community within a specific region, with an assigned support representative and fee structure. The response will include a `meta.details` array with updated permissions relative to the just-created community, as you would expect when fetching community details later.
   * Create a new community
   */
  async createCommunity(
    requestParameters: CreateCommunityRequest
  ): Promise<CreateCommunityResponse> {
    const response = await this.createCommunityRaw(requestParameters)
    return await response.value()
  }

  /**
   * Declines a pending potential invite for a community using the provided decline reason.
   * Decline a potential invite.
   */
  async declinePotentialInviteRaw(
    requestParameters: DeclinePotentialInviteRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling declinePotentialInvite.'
      )
    }

    if (
      requestParameters.potentialInviteKey === null ||
      requestParameters.potentialInviteKey === undefined
    ) {
      throw new runtime.RequiredError(
        'potentialInviteKey',
        'Required parameter requestParameters.potentialInviteKey was null or undefined when calling declinePotentialInvite.'
      )
    }

    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling declinePotentialInvite.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/{communityKey}/potentialInvites/{potentialInviteKey}/decline`
        .replace(
          `{${'communityKey'}}`,
          encodeURIComponent(String(requestParameters.communityKey))
        )
        .replace(
          `{${'potentialInviteKey'}}`,
          encodeURIComponent(String(requestParameters.potentialInviteKey))
        ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: DeclinePotentialInviteRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Declines a pending potential invite for a community using the provided decline reason.
   * Decline a potential invite.
   */
  async declinePotentialInvite(
    requestParameters: DeclinePotentialInviteRequest
  ): Promise<void> {
    await this.declinePotentialInviteRaw(requestParameters)
  }

  /**
   * Calling this endpoint, you get the list of the academic years from programs.
   * List of academic years.
   */
  async fetchAcademicYearsRaw(
    requestParameters: FetchAcademicYearsRequest
  ): Promise<runtime.ApiResponse<FetchAcademicYearsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.isLC !== undefined) {
      queryParameters['isLC'] = requestParameters.isLC
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/fetchAcademicYears`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchAcademicYearsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Calling this endpoint, you get the list of the academic years from programs.
   * List of academic years.
   */
  async fetchAcademicYears(
    requestParameters?: FetchAcademicYearsRequest
  ): Promise<FetchAcademicYearsResponse> {
    const response = await this.fetchAcademicYearsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Fetch an existing community
   */
  async fetchCommunityRaw(
    requestParameters: FetchCommunityRequest
  ): Promise<runtime.ApiResponse<CommunityDetail>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchCommunity.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/{communityKey}`.replace(
        `{${'communityKey'}}`,
        encodeURIComponent(String(requestParameters.communityKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CommunityDetailFromJSON(jsonValue)
    )
  }

  /**
   * Fetch an existing community
   */
  async fetchCommunity(
    requestParameters: FetchCommunityRequest
  ): Promise<CommunityDetail> {
    const response = await this.fetchCommunityRaw(requestParameters)
    return await response.value()
  }

  /**
   * Report of all enrollments for every family the current user can access within a community, for a single academic year.
   */
  async fetchCommunityFamiliesReportRaw(
    requestParameters: FetchCommunityFamiliesReportRequest
  ): Promise<runtime.ApiResponse<CommunityFamiliesReportResponse>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchCommunityFamiliesReport.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.year !== undefined) {
      queryParameters['year'] = requestParameters.year
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/{communityKey}/families/report`.replace(
        `{${'communityKey'}}`,
        encodeURIComponent(String(requestParameters.communityKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CommunityFamiliesReportResponseFromJSON(jsonValue)
    )
  }

  /**
   * Report of all enrollments for every family the current user can access within a community, for a single academic year.
   */
  async fetchCommunityFamiliesReport(
    requestParameters: FetchCommunityFamiliesReportRequest
  ): Promise<CommunityFamiliesReportResponse> {
    const response = await this.fetchCommunityFamiliesReportRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Fetches the invites associated with a community.
   * Fetch community invites
   */
  async fetchCommunityInvitesRaw(
    requestParameters: FetchCommunityInvitesRequest
  ): Promise<runtime.ApiResponse<FetchCommunityInvitesResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.communityKey !== undefined) {
      queryParameters['communityKey'] = requestParameters.communityKey
    }

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    if (requestParameters.status !== undefined) {
      queryParameters['status'] = requestParameters.status
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/communities/invites`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchCommunityInvitesResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches the invites associated with a community.
   * Fetch community invites
   */
  async fetchCommunityInvites(
    requestParameters?: FetchCommunityInvitesRequest
  ): Promise<FetchCommunityInvitesResponse> {
    const response = await this.fetchCommunityInvitesRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   */
  async fetchCommunityOptionsRaw(
    requestParameters: FetchCommunityOptionsRequest
  ): Promise<runtime.ApiResponse<CommunityOptions>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/options`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CommunityOptionsFromJSON(jsonValue)
    )
  }

  /**
   */
  async fetchCommunityOptions(
    requestParameters?: FetchCommunityOptionsRequest
  ): Promise<CommunityOptions> {
    const response = await this.fetchCommunityOptionsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Fetches the available reasons for declining a potential invite.
   * Fetch potential invite decline reasons
   */
  async fetchPotentialInviteDeclineReasonsRaw(
    requestParameters: FetchPotentialInviteDeclineReasonsRequest
  ): Promise<runtime.ApiResponse<FetchPotentialInviteDeclineReasonsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/potentialInvites/declineReasons`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchPotentialInviteDeclineReasonsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches the available reasons for declining a potential invite.
   * Fetch potential invite decline reasons
   */
  async fetchPotentialInviteDeclineReasons(
    requestParameters?: FetchPotentialInviteDeclineReasonsRequest
  ): Promise<FetchPotentialInviteDeclineReasonsResponse> {
    const response = await this.fetchPotentialInviteDeclineReasonsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   *      Returns the list of potential invites (Returning Families and LCD Referrals) for a given community.     Supports filtering by academic year, source, status, and a name search.     The actor must have the Family/Invite permission to access this endpoint.     Contact emails are masked for Returning Families and shown in full for LCD Referrals.
   * Fetch a paginated list of potential invites for a community.
   */
  async fetchPotentialInvitesRaw(
    requestParameters: FetchPotentialInvitesRequest
  ): Promise<runtime.ApiResponse<FetchPotentialInvitesResponse>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchPotentialInvites.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    if (requestParameters.source !== undefined) {
      queryParameters['source'] = requestParameters.source
    }

    if (requestParameters.status !== undefined) {
      queryParameters['status'] = requestParameters.status
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community/{communityKey}/potentialInvites`.replace(
        `{${'communityKey'}}`,
        encodeURIComponent(String(requestParameters.communityKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchPotentialInvitesResponseFromJSON(jsonValue)
    )
  }

  /**
   *      Returns the list of potential invites (Returning Families and LCD Referrals) for a given community.     Supports filtering by academic year, source, status, and a name search.     The actor must have the Family/Invite permission to access this endpoint.     Contact emails are masked for Returning Families and shown in full for LCD Referrals.
   * Fetch a paginated list of potential invites for a community.
   */
  async fetchPotentialInvites(
    requestParameters: FetchPotentialInvitesRequest
  ): Promise<FetchPotentialInvitesResponse> {
    const response = await this.fetchPotentialInvitesRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns some communities within a radius of either a postal code (preferred) or a city and state. If programs are provided, then only communities listing all of the requested programs will be included.
   * Find nearby communities with your desired programs so you can reach out about enrolling.
   */
  async searchPublicCommunitiesRaw(
    requestParameters: SearchPublicCommunitiesRequest
  ): Promise<runtime.ApiResponse<SearchPublicCommunitiesReply>> {
    const queryParameters: any = {}

    if (requestParameters.postalCode !== undefined) {
      queryParameters['postalCode'] = requestParameters.postalCode
    }

    if (requestParameters.city !== undefined) {
      queryParameters['city'] = requestParameters.city
    }

    if (requestParameters.state !== undefined) {
      queryParameters['state'] = requestParameters.state
    }

    if (requestParameters.milesRadius !== undefined) {
      queryParameters['milesRadius'] = requestParameters.milesRadius
    }

    if (requestParameters.usCitiesKey !== undefined) {
      queryParameters['usCitiesKey'] = requestParameters.usCitiesKey
    }

    if (requestParameters.programs) {
      queryParameters['programs'] = requestParameters.programs
    }

    if (requestParameters.singleNearest !== undefined) {
      queryParameters['singleNearest'] = requestParameters.singleNearest
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request({
      path: `/communities/search`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SearchPublicCommunitiesReplyFromJSON(jsonValue)
    )
  }

  /**
   * Returns some communities within a radius of either a postal code (preferred) or a city and state. If programs are provided, then only communities listing all of the requested programs will be included.
   * Find nearby communities with your desired programs so you can reach out about enrolling.
   */
  async searchPublicCommunities(
    requestParameters?: SearchPublicCommunitiesRequest
  ): Promise<SearchPublicCommunitiesReply> {
    const response = await this.searchPublicCommunitiesRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Returns public community details. Note that the `location.distanceMiles`, while included for consistency with the search results, is not meaningful here, and so should be ignored.
   * Review the public details of a community discovered by a location search.
   */
  async searchPublicCommunityRaw(
    requestParameters: SearchPublicCommunityRequest
  ): Promise<runtime.ApiResponse<PublicCommunity>> {
    if (
      requestParameters.publicCommunityId === null ||
      requestParameters.publicCommunityId === undefined
    ) {
      throw new runtime.RequiredError(
        'publicCommunityId',
        'Required parameter requestParameters.publicCommunityId was null or undefined when calling searchPublicCommunity.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request({
      path: `/communities/search/{publicCommunityId}`.replace(
        `{${'publicCommunityId'}}`,
        encodeURIComponent(String(requestParameters.publicCommunityId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicCommunityFromJSON(jsonValue)
    )
  }

  /**
   * Returns public community details. Note that the `location.distanceMiles`, while included for consistency with the search results, is not meaningful here, and so should be ignored.
   * Review the public details of a community discovered by a location search.
   */
  async searchPublicCommunity(
    requestParameters: SearchPublicCommunityRequest
  ): Promise<PublicCommunity> {
    const response = await this.searchPublicCommunityRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns communities that belongs the requested country.     The result should include:      - current active/published communities and those in future *      - Include draft communities *     - Include communities without programs .
   * Search for international communities based on a requested country value,    its deliver the the community information, the community contact and the programs related in case it has.
   */
  async searchPublicInternationalCommunitiesRaw(
    requestParameters: SearchPublicInternationalCommunitiesRequest
  ): Promise<runtime.ApiResponse<SearchPublicCommunitiesReply>> {
    if (
      requestParameters.country === null ||
      requestParameters.country === undefined
    ) {
      throw new runtime.RequiredError(
        'country',
        'Required parameter requestParameters.country was null or undefined when calling searchPublicInternationalCommunities.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.country !== undefined) {
      queryParameters['country'] = requestParameters.country
    }

    if (requestParameters.programs) {
      queryParameters['programs'] = requestParameters.programs
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request({
      path: `/communities/international/search`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SearchPublicCommunitiesReplyFromJSON(jsonValue)
    )
  }

  /**
   * Returns communities that belongs the requested country.     The result should include:      - current active/published communities and those in future *      - Include draft communities *     - Include communities without programs .
   * Search for international communities based on a requested country value,    its deliver the the community information, the community contact and the programs related in case it has.
   */
  async searchPublicInternationalCommunities(
    requestParameters: SearchPublicInternationalCommunitiesRequest
  ): Promise<SearchPublicCommunitiesReply> {
    const response = await this.searchPublicInternationalCommunitiesRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Returns public community details
   * Search for international community based on a requested community Id encoded,   it delivers the community information, the community contact and the programs related in case it has.
   */
  async searchPublicInternationalCommunityRaw(
    requestParameters: SearchPublicInternationalCommunityRequest
  ): Promise<runtime.ApiResponse<PublicInternationalCommunity>> {
    if (
      requestParameters.publicCommunityId === null ||
      requestParameters.publicCommunityId === undefined
    ) {
      throw new runtime.RequiredError(
        'publicCommunityId',
        'Required parameter requestParameters.publicCommunityId was null or undefined when calling searchPublicInternationalCommunity.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/communities/international/search/{publicCommunityId}`.replace(
        `{${'publicCommunityId'}}`,
        encodeURIComponent(String(requestParameters.publicCommunityId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicInternationalCommunityFromJSON(jsonValue)
    )
  }

  /**
   * Returns public community details
   * Search for international community based on a requested community Id encoded,   it delivers the community information, the community contact and the programs related in case it has.
   */
  async searchPublicInternationalCommunity(
    requestParameters: SearchPublicInternationalCommunityRequest
  ): Promise<PublicInternationalCommunity> {
    const response = await this.searchPublicInternationalCommunityRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Accepts info about the person requesting contact, which programs they are interested in at which community, and records their acceptance of the relevant legal notices. Be sure to read the description of the 400 Error for details on field-level error reporting, so you can present backend validation errors to the would-be form submitter.
   * Request someone contact you with more details about a community and its programs.
   */
  async submitContactFormRaw(
    requestParameters: SubmitContactFormRequest
  ): Promise<runtime.ApiResponse<SubmitContactFormParams>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request({
      path: `/communities/contact`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: SubmitContactFormParamsToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SubmitContactFormParamsFromJSON(jsonValue)
    )
  }

  /**
   * Accepts info about the person requesting contact, which programs they are interested in at which community, and records their acceptance of the relevant legal notices. Be sure to read the description of the 400 Error for details on field-level error reporting, so you can present backend validation errors to the would-be form submitter.
   * Request someone contact you with more details about a community and its programs.
   */
  async submitContactForm(
    requestParameters?: SubmitContactFormRequest
  ): Promise<SubmitContactFormParams> {
    const response = await this.submitContactFormRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Create or update a community within a specific region, with an assigned support representative and fee structure.
   * Update an existing community
   */
  async updateCommunityRaw(
    requestParameters: UpdateCommunityRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updateCommunity.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/community`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: UpdateCommunityToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Create or update a community within a specific region, with an assigned support representative and fee structure.
   * Update an existing community
   */
  async updateCommunity(
    requestParameters: UpdateCommunityRequest
  ): Promise<void> {
    await this.updateCommunityRaw(requestParameters)
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchCommunityInvitesStatusEnum {
  InProgress = 'InProgress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
}
/**
 * @export
 * @enum {string}
 */
export enum SearchPublicCommunitiesProgramsEnum {
  Foundations = 'Foundations',
  Essentials = 'Essentials',
  ChallengeA = 'Challenge A',
  ChallengeB = 'Challenge B',
  ChallengeI = 'Challenge I',
  ChallengeIi = 'Challenge II',
  ChallengeIii = 'Challenge III',
  ChallengeIv = 'Challenge IV',
}
/**
 * @export
 * @enum {string}
 */
export enum SearchPublicInternationalCommunitiesProgramsEnum {
  Foundations = 'Foundations',
  Essentials = 'Essentials',
  ChallengeA = 'Challenge A',
  ChallengeB = 'Challenge B',
  ChallengeI = 'Challenge I',
  ChallengeIi = 'Challenge II',
  ChallengeIii = 'Challenge III',
  ChallengeIv = 'Challenge IV',
}
